import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import './CustomDatePicker.css';

export class CustomDatePicker extends Component {
  handleChange = (date) => {
    const { onChange } = this.props;
    if (onChange) {
      if (date) {
        const momentDate = moment(date);
        onChange(momentDate, momentDate.format('YYYY-MM-DD'));
      } else {
        onChange(null, '');
      }
    }
  };

  render() {
    const { value, placeholder, disabled, style, disabledDate, portalId = "portal-datepicker-root" } = this.props;

    let selectedDate = null;
    if (value) {
      if (moment.isMoment(value)) {
        selectedDate = value.toDate();
      } else if (value instanceof Date) {
        selectedDate = value;
      } else {
        selectedDate = new Date(value);
      }
    }

    const filterDate = (date) => {
      if (disabledDate) {
        return !disabledDate(moment(date));
      }
      return true;
    };

    return (
      <div className={`custom-datepicker-container ${disabled ? 'disabled' : ''}`} style={style}>
        <DatePicker
          selected={selectedDate}
          onChange={this.handleChange}
          placeholderText={placeholder || "Select Date"}
          disabled={disabled}
          filterDate={disabledDate ? filterDate : undefined}
          dateFormat="yyyy-MM-dd"
          className="custom-datepicker-input"
          popperClassName="custom-datepicker-popper"
          popperPlacement="bottom-start"
          portalId={portalId || undefined}
        />
        <span className="custom-datepicker-icon">
          <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </svg>
        </span>
      </div>
    );
  }
}

export default CustomDatePicker;
